import { useState, useCallback } from 'react';

export function useSemaphore(initialCount: number = 1) {
  const [taken, setTaken] = useState(0);

  const acquire = useCallback(() => {
    setTaken((prev) => {
      if (prev < initialCount) {
        return prev + 1;
      }
      return prev; // no-op if already full
    });
  }, [initialCount]);

  const release = useCallback(() => {
    setTaken((prev) => {
      if (prev > 0) {
        return prev - 1;
      }
      return prev; // no-op if already at 0
    });
  }, []);

  const isLocked = taken >= initialCount;

  return {
    acquire,
    release,
    isLocked,
  };
}
